import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Pages
import HeaderNavBase from './page_bases/base_headernav';
import HeaderBase from './page_bases/base_header';
import Login from './pages/login';
import PasswordReset from './pages/pass_reset';
import NewPassword from './components/new_password';
import LogoutPage from './pages/logout';
import UserProfile from './pages/user_profile';
import UserManagement from './pages/user_management';
import UserLocationManagement from './pages/user_location_management';
import LocationManagement from './pages/location_management';
import LocationUsersManagement from './pages/location_user_management';
import LocationList from './pages/locations';
import LoadBatteryMap from './pages/batterymap';
import UnitSnapshot from './pages/unit_snapshot';
import UnitTrend from './pages/unit_trend';
import StringTrend from './pages/string_trend';
import SystemTrend from './pages/system_trend';
import DischargeEvents from './pages/discharge_events';
import SystemDischargeTrend from './pages/system_discharge_trend';
import StringDischargeTrend from './pages/string_discharge_trend';
import UnitDischargeTrend from './pages/unit_discharge_trend';
import UnitDischargeSnapshot from './pages/unit_discharge_snapshot';
import Realtime from './pages/realtime';
import SystemAnalysis from './pages/analysis';
import SystemEvents from './pages/location_events';
import Events from './pages/events';

// Settings pages
import EmailSettings from './pages/settings/location_email_settings';

import NotFound from './pages/errors/notfound';
import Forbidden from './pages/errors/forbidden';

// Components
import Map from './components/map';
import LocationsTable from './components/locations_table';
import Loader from './components/loader';
import { AuthProvider, useAuth } from './context/auth_context';


// Protect the routes passed as children
function ProtectedLayout({ children }) {
	const { isAuthenticated } = useAuth();
	const location = useLocation();

	if (isAuthenticated === undefined) {
		return <Loader />;
	}

	if (!isAuthenticated) {
		return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} />;
	}

	return children;
}

export default function OBVM() {
	return (
		<AuthProvider>
			<Routes>
				{/* Base Route - No Layout*/}
				<Route path='/' element={<Navigate to="/list" />} />

				{/* Public routes */}
				<Route path='/login' element={<Login />} />
				<Route path='/passwordreset' element={<PasswordReset />} />
				<Route path='/passwordreset/setpassword' element={<NewPassword />} />
				<Route path="/logout" element={<LogoutPage />} />

				{/* Protected routes - Header Only - Locations List, Map, Events */}
				<Route element={ <ProtectedLayout><HeaderBase /></ProtectedLayout> }>
					<Route element={<LocationList />} >
						<Route path="/list" element={<LocationsTable />} />
						<Route path="/map" element={<Map />} />
						<Route path="/events" element={<Events />} />
					</Route>
					<Route path="/profile" element={<UserProfile />} />
					<Route path="/admin/users" element={<UserManagement />} />
					<Route path="/admin/users/:userId" element={<UserProfile />} />
					<Route path="/admin/users/:userId/locations" element={<UserLocationManagement />} />
					<Route path="/admin/locations" element={<LocationManagement />} />
					<Route path="/admin/locations/:locationNum" element={<LocationUsersManagement />} />
				</Route>

				{/* Protected routes - Header and Nav - Location Details */}
				<Route element={ <ProtectedLayout><HeaderNavBase /></ProtectedLayout> }>
					<Route path="/location/:locationNum/" element={<LoadBatteryMap />} />
					<Route path="/location/:locationNum/analysis" element={<SystemAnalysis />} />
					<Route path="/location/:locationNum/events" element={<SystemEvents />} />
					<Route path="/location/:locationNum/snapshot" element={<UnitSnapshot />} />
					<Route path="/location/:locationNum/trend/system" element={<SystemTrend />} />
					<Route path="/location/:locationNum/trend/string" element={<StringTrend />} />
					<Route path="/location/:locationNum/trend/unit" element={<UnitTrend />} />
					<Route path="/location/:locationNum/discharges" element={<DischargeEvents />} />
					<Route path="/location/:locationNum/discharges/:eventDateTime" element={<SystemDischargeTrend />} />
					<Route path="/location/:locationNum/discharges/:eventDateTime/snapshot" element={<UnitDischargeSnapshot />} />
					<Route path="/location/:locationNum/discharges/:eventDateTime/string" element={<StringDischargeTrend />} />
					<Route path="/location/:locationNum/discharges/:eventDateTime/unit" element={<UnitDischargeTrend />} />
					<Route path="/location/:locationNum/realtime" element={<Realtime />} />
					<Route path="/location/:locationNum/settings/email" element={<EmailSettings />} />
				</Route>

				{/* Error Routes */}
				<Route path="/403" element={<Forbidden />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</AuthProvider>
	);
}
